import React from 'react'
import Extra_header from './Extra_header'
import Extra_row from './Extra_row'

const ExtraCurricular = ({data}) => {

   
  return (
    <div>
        
        <Extra_header/>
        <Extra_row data={data}/>
    </div>
  )
}

export default ExtraCurricular